import { IComponentOptions } from "angular";
import { ProgressiveDefinitionMachinesEditViewComponentController } from "./controller";

export const vsComponentName = "progressiveDefinitionMachinesEditView";

export const progressiveDefinitionMachinesEditViewComponentOptions: IComponentOptions =
  {
    controller: ProgressiveDefinitionMachinesEditViewComponentController,
    controllerAs: "progressiveMachinesEditController",
    template: require("!html-loader!./index.html").default,
    bindings: {
      progressiveDefinition: "<",
      currentProgressiveDefinitionMachines: "<",
    },
  };
